
interface HeroProps {
  onOpenForm: () => void;
}

export default function Hero({ onOpenForm }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/780e78bb0d830f51de952dadc10616b4.jpeg"
          alt="專業網站建置服務背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Logo */}
      <div className="absolute top-8 left-8 z-10">
        <img
          src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/6b985e9c6d5a525bb578b4f0faa78a26.png"
          alt="Logo"
          className="h-12 w-auto"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          0元一頁式網站<br />
          讓您先有一個「能用的入口」
        </h1>
        <p className="text-xl md:text-2xl text-white/95 font-medium leading-relaxed max-w-3xl mx-auto">
          不用一次花十幾萬<br />
          先把網站跑起來，再決定要不要擴大
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/consultation"
            className="inline-flex items-center justify-center px-8 py-4 bg-teal-500 text-white text-lg font-semibold rounded-lg hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-chat-smile-3-line mr-2 text-xl"></i>
            進一步諮詢與了解
          </a>
          <a
            href="/annual-plan"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 text-lg font-semibold rounded-lg hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line mr-2 text-xl"></i>
            了解年度管理方案
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="mt-16 animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
